import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { IMAGES, STATS } from "@/data/content";
import { CountUp } from "./CountUp";

export default function Hero() {
  const go = (href) => document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });

  return (
    <section id="hero" className="relative min-h-screen flex items-center overflow-hidden" data-testid="hero-section">
      <div className="absolute inset-0">
        <img src={IMAGES.hero} alt="Senior accompagné lors d'une promenade" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-r from-cream via-cream/90 to-cream/30" />
        <div className="absolute inset-0 bg-gradient-to-t from-cream/80 via-transparent to-transparent" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-10 w-full pt-28 pb-16">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
          className="max-w-2xl"
        >
          <span className="inline-block text-xs md:text-sm font-semibold uppercase tracking-[0.25em] text-gold mb-6">
            Accompagnement & loisirs senior
          </span>
          <h1 className="font-display text-5xl sm:text-6xl lg:text-7xl font-medium leading-[1.05] tracking-tight text-forest">
            Vivre chez soi <br />en toute <span className="italic shine">sérénité.</span>
          </h1>
          <p className="mt-7 text-base md:text-lg text-forest/75 leading-relaxed max-w-xl">
            Proxilia accompagne les seniors dans leur quotidien avec une présence humaine, des services personnalisés et des moments de partage.
          </p>

          <div className="mt-9 flex flex-col sm:flex-row gap-4">
            <button
              onClick={() => go("#services")}
              className="group bg-forest text-cream px-8 py-4 rounded-full font-medium transition-all hover:bg-forestdark active:scale-[0.98] flex items-center justify-center gap-2"
              data-testid="hero-services-btn"
            >
              Découvrir nos services
              <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
            </button>
            <button
              onClick={() => go("#rappel")}
              className="border-2 border-forest text-forest px-8 py-4 rounded-full font-medium transition-all hover:bg-forest hover:text-cream active:scale-[0.98]"
              data-testid="hero-contact-btn"
            >
              Demander un rendez-vous
            </button>
          </div>

          <div className="mt-14 grid grid-cols-3 gap-4 max-w-xl">
            {STATS.map((s, i) => (
              <motion.div
                key={s.label}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.5 + i * 0.12, duration: 0.6 }}
                className="glass rounded-2xl px-4 py-5 text-center transition-transform duration-300 hover:-translate-y-1"
                data-testid={`hero-stat-${i}`}
              >
                <div className="font-display text-2xl md:text-3xl text-forest font-semibold">
                  <CountUp value={s.value} />
                </div>
                <div className="mt-1 text-[11px] md:text-xs text-forest/60 leading-tight">{s.label}</div>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
}
